import React, { useState, useEffect } from "react"
import { getRequest, pathname }       from '@helpers/javascript/javascript'
import Combobox                       from '@shared/combobox'
import { minToString }                from '@helpers/javascript/date_helpers'

export const TechnicianSelect = ({
  technicians, 
  workorderState,
  onTechChange,
  checkAvailability
}) => {
  const [availabilityStatus, setAvailabilityStatus] = useState({ 
    message: '', 
    available: null, 
    visible: false 
  })

  const {technicianId, predictedDuration, datePlanned} = workorderState

  useEffect(() => {
    if (!checkAvailability) return
    
    setAvailabilityStatus({ message: '', available: null, visible: false })
    
    if (!technicianId) return
    if (!datePlanned || !predictedDuration) return

    const path = "/workorders/form/tech_availability"
    const format = "json"
    const params = {
      technician: technicianId,
      date_planned: datePlanned,
      predicted_duration: minToString(predictedDuration)
    }
    const url = pathname({ path, params, format }) 

    getRequest(url).then(res => {
      setAvailabilityStatus({
        message:   res.message,
        available: res.available,
        visible:   true
      })
    })   
  }, [technicianId, datePlanned, predictedDuration])

  const handleTechnicianSelect = tech => {
    onTechChange(tech.id)
  }

  return (
    <div className="w-100">
      <Combobox 
        options         = { technicians }
        onSelectElement = { handleTechnicianSelect }
        placeholder     = { I18n.t("workorders.select") }
        value           = { technicianId }
        label           = { I18n.t("workorders.head_technician") }
        className       = "form-group"
      />

      {availabilityStatus.visible && (
        <div className={`availability ${availabilityStatus.available ? '' : 'busy'}`}>
          {availabilityStatus.message}
        </div>
      )}
    </div>
  )
}